import ScrollToTopOnMount from "../../components/ScrollToTopOnMount/ScrollToTopOnMount";
import AllCollections from "../../layouts/AllCollections/AllCollections"


const AllCollectionsPage = () => {
    return(
        <>
            <ScrollToTopOnMount />
            <AllCollections />
        </>
        
    )
}

export default AllCollectionsPage;